import React from "react";
import { Card } from "@/components/ui/card";

export const KpiCard = ({ label, value, sublabel, icon: Icon, accent = "slate", testid }) => {
  const accents = {
    slate: "text-slate-900",
    orange: "text-orange-600",
    emerald: "text-emerald-600",
    amber: "text-amber-600",
    blue: "text-blue-600",
    red: "text-red-600",
  };
  return (
    <Card data-testid={testid} className="p-6 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</p>
          <p className={`mt-3 text-3xl font-bold tracking-tighter ${accents[accent]}`} style={{ fontFamily: "Manrope, sans-serif" }}>
            {value}
          </p>
          {sublabel && <p className="mt-1 text-sm text-slate-500">{sublabel}</p>}
        </div>
        {Icon && (
          <div className={`p-2 rounded-lg bg-slate-50 ${accents[accent]}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </Card>
  );
};

export default KpiCard;
